<template>
  <div>
    <az-toolbar>
      <az-call-to-action active slot="actions" css-class="no-mobile" @click="novo"
                         v-az-auth="'DeclaracoesTermos.Atualizar'">
        <v-icon>add_circle</v-icon>
        Novo
      </az-call-to-action>
      <az-search slot="simpleSearch"
                 :filter="filtrosAtivos"
                 @simple-search="eventoBuscaSimples"
                 @remove-filter="eventoRemoverFiltro"
                 simple-search-placeholder="Informe o conteúdo">
      </az-search>
    </az-toolbar>
    <termos-configuracao-tabela :itens="itens"
                                :paginacao="$store.state.termosBusca.paginacao"
                                :paginas="paginas"
                                :total-itens="totalItens"
                                @paginar="eventoPaginar"
                                @editar="eventoEditar"
                                @visualizar="eventoVisualizar"
                                @ativar="ativarTermo"
                                @inativar="inativarTermo"
    />
  </div>
</template>

<script>
import TermosConfiguracaoTabela from "@/views/configuracao/termos/TermosConfiguracaoTabela";
import _ from "lodash";
import {mapState} from "vuex";
import {filters} from "@azinformatica/loki";
import {actionTypes, mutationTypes, situacoesAtivoInativo, tiposTermoAceite} from "@/commons/constants";

export default {
  name: "TermosConfiguracao",
  components: {TermosConfiguracaoTabela},
  data() {
    return {
      situacoesAtivoInativo,
      tiposTermoAceite,
      filtrosInterno: _.cloneDeep(this.$store.state.termosBusca.filtros),
      paginas: 0,
      totalItens: 0,
      itens: []
    }
  },
  computed: {
    ...mapState(['termosBusca']),
    filtrosAtivos() {
      const filtros = _.cloneDeep(this.termosBusca.filtros)
      const filtrosAtivos = {}
      for (let [chave, val] of Object.entries(filtros)) {
        if (filtros[chave].value) {
          val.valueTruncated = filters.azTitleCase(val.value, 10)
          filtrosAtivos[chave] = val
        }
      }
      return filtrosAtivos
    }
  },
  async mounted() {
    await this.buscar()
  },
  methods: {
    async eventoBuscaSimples(valor) {
      if(!!valor && !!valor.trim()) {
        this.filtrosInterno.conteudo.value = valor
      }
      await this.buscar()
    },
    async buscar() {
      this.$store.commit(mutationTypes.SET_FILTROS_BUSCA_TERMOS, _.cloneDeep(this.filtrosInterno))
      this.setMensagemLoading('Carregando Termos...')
      const response = await this.$store.dispatch(actionTypes.BUSCAR_TERMOS_ACEITE)
      this.itens = response.termos
      this.paginas = response.totalPages
      this.totalItens = response.totalElements
    },
    eventoRemoverFiltro(propriedade) {
      if (this.filtrosInterno && this.filtrosInterno.hasOwnProperty(propriedade)) {
        this.filtrosInterno[propriedade].value = this.filtrosInterno[propriedade].default
      }
      this.buscar()
    },
    async ativarTermo(idAtivar){
      const termoAtivar = this.itens.find(termo => termo.id === idAtivar)
      termoAtivar.situacao = 'ATIVO'
      await this.$store.dispatch(actionTypes.ATUALIZAR_TERMO_ACEITE, {termo: termoAtivar})
      this.mostrarNotificacaoSucesso("Termo ativado com sucesso!")
    },
    async inativarTermo(idInativar){
      const termoInativar = this.itens.find(termo => termo.id === idInativar)
      termoInativar.situacao = 'INATIVO'
      await this.$store.dispatch(actionTypes.ATUALIZAR_TERMO_ACEITE, {termo: termoInativar})
      this.mostrarNotificacaoSucesso("Termo inativado com sucesso!")
    },
    eventoPaginar(paginacao) {
      this.$store.commit(mutationTypes.SET_PAGINACAO_BUSCA_TERMOS, paginacao)
      this.buscar()
    },
    eventoEditar(termoId) {
      this.$router.push({name: 'termoAtualizacao', params: {id: termoId}, query: {edicao: true}})
    },
    eventoVisualizar(termoId) {
      this.$router.push({name: 'termoAtualizacao', params: {id: termoId}})
    },
    novo() {
      this.$router.push({name: 'termoNovo'})
    }
  }
}
</script>